export default "__VITE_ASSET__hWLGpN_h__"